import { create } from "zustand";
import type { AppFeatures } from "@/api/app";
import { FEATURES_OFF, fetchAppFeatures } from "@/api/app";

type AppFeaturesState = AppFeatures & {
  load: () => Promise<void>;
};

/** Выключатели бэка. Пока не загрузились или бэк старый — всё выключено. */
export const useAppFeatures = create<AppFeaturesState>((set) => ({
  ...FEATURES_OFF,
  load: async () => {
    const features = await fetchAppFeatures();
    set({ promo_subscription: undefined, ...features });
  },
}));
